interface WorkspaceTabsProps {
  middleFrameTab: 'album' | 'history' | 'configuration'
  setMiddleFrameTab: (tab: 'album' | 'history' | 'configuration') => void
  ariaLabel: string
  albumLabel: string
  historyLabel: string
  configurationLabel: string
}

export function WorkspaceTabs({
  middleFrameTab,
  setMiddleFrameTab,
  ariaLabel,
  albumLabel,
  historyLabel,
  configurationLabel
}: WorkspaceTabsProps): JSX.Element {
  return (
    <div className="panel-section-switch" role="tablist" aria-label={ariaLabel}>
      <button
        className={middleFrameTab === 'album' ? 'tab is-active' : 'tab'}
        onClick={() => setMiddleFrameTab('album')}
        type="button"
        role="tab"
        aria-selected={middleFrameTab === 'album'}
      >
        {albumLabel}
      </button>
      <button
        className={middleFrameTab === 'history' ? 'tab is-active' : 'tab'}
        onClick={() => setMiddleFrameTab('history')}
        type="button"
        role="tab"
        aria-selected={middleFrameTab === 'history'}
      >
        {historyLabel}
      </button>
      <button
        className={middleFrameTab === 'configuration' ? 'tab is-active' : 'tab'}
        onClick={() => setMiddleFrameTab('configuration')}
        type="button"
        role="tab"
        aria-selected={middleFrameTab === 'configuration'}
      >
        {configurationLabel}
      </button>
    </div>
  )
}
